<!--
  单笔话费流量充值
  lovi 2020-07-29
-->
<template>
  <div class="recharge">
    <div class="breadcrumb-wrap">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("common.eepay") }}</BreadcrumbItem>
        <BreadcrumbItem>
          {{ $t("recharge.phoneFeeDataTraffic") }}
        </BreadcrumbItem>
      </Breadcrumb>
      <a class="returnA" @click="returnFun" v-if="showReturn">
        {{ $t("common.back") }}
      </a>
    </div>
    <div class="recharge-type" v-if="!showReturn">
      <a
        href="javascript:void(0);"
        :class="{ active: rechargeType == 0 }"
        @click="changeType(0)"
      >
        {{ $t("recharge.phoneFeeRecharge") }}
      </a>
      <a
        href="javascript:void(0);"
        :class="{ active: rechargeType == 1 }"
        @click="changeType(1)"
      >
        {{ $t("recharge.dataTrafficRecharge") }}
      </a>
    </div>
    <charge
      ref="childModal"
      :rechargeType.sync="rechargeType"
      :showReturn.sync="showReturn"
    />
  </div>
</template>

<script>
import Charge from "./charge";
export default {
  name: "recharge-single",
  components: {
    Charge
  },
  data() {
    return {
      rechargeType: 0, //充值类型，0为话费，1为流量
      tabNum: 0,
      showReturn: false //显示返回
    };
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    returnFun() {
      // debugger
      this.$refs.childModal.returnFun();
      // console.log(this.$refs.childModal.returnFun())
    },
    changeType(type) {
      //修改充值类别
      let vm = this;
      vm.rechargeType = type;
    }
  },
  watch: {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
@imgUrl: "~@/assets/images/";
.recharge-type {
  margin-top: 15px;
  height: 45px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #bfbfbf;
  a {
    height: 100%;
    font-size: 18px;
    color: #4a4a4a;
    display: flex;
    align-items: center;
    &.active {
      color: #2042ab;
      position: relative;
      &:after {
        content: "";
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background: #2042ab;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
  a + a {
    margin-left: 50px;
  }
}
</style>
